const checkContents = (offerIsSaveable: any) => {
  if (offerIsSaveable.zips === false) {
    return 'Make sure your zip codes are valid.';
  }
  if (offerIsSaveable.states === false) {
    return 'Make sure your states are valid as a fully capitalized word or abbreviation.';
  }
  if (offerIsSaveable.enddateExists === false) {
    return 'You need to select an enddate.';
  }
  return '';
};

export const ENUM_POINT_CHANGE_TYPE = {
  PROMO: 'promo',
  ONETIME: 'onetime',
};

export const OFFER_FIELDS = {
  isPointsChangeScheduled: 'ispointschangescheduled',
  pointsChangeType: 'pointschangetype',
  pointsChangeStartDate: 'pointschangestartdate',
  pointsChangeStartValue: 'pointschangestartvalue',
  pointsChangeTimezone: 'pointschangestimezone',
  pointsChangeEndDate: 'pointschangeenddate',
  pointsChangeEndValue: 'pointschangeendvalue',

  //Extra fields
  pointsChangeStartDetails: 'pointschangestartdetails',
  pointsChangeEndDetails: 'pointschangeenddetails',
};

export default checkContents;
